__turbopack_context__.v({
  "actions": "page-not-found-module-scss-module__p_F9ZG__actions",
  "card": "page-not-found-module-scss-module__p_F9ZG__card",
  "content": "page-not-found-module-scss-module__p_F9ZG__content",
  "ctaButton": "page-not-found-module-scss-module__p_F9ZG__ctaButton",
  "description": "page-not-found-module-scss-module__p_F9ZG__description",
  "page": "page-not-found-module-scss-module__p_F9ZG__page",
  "textBlock": "page-not-found-module-scss-module__p_F9ZG__textBlock",
  "title": "page-not-found-module-scss-module__p_F9ZG__title",
  "visualSlot": "page-not-found-module-scss-module__p_F9ZG__visualSlot",
});
